import React, {Component} from "react";
import config from 'react-global-configuration';

class PrimIdFilter extends Component {
    state = {
        is_prim_id: false,
    };
    componentDidMount(){

    }
    resetPrimIdFilter() {
        this.setState({
            is_prim_id: 0,
        })
    }

    handleCheckPrimId(e){
        var is_prim_id = 1;
        if (e.target.checked === true) {
            this.setState({is_prim_id: 1})
        } else {
            this.setState({is_prim_id: 0});
            is_prim_id = 0;
        }
        this.props.onSelectPrimId(is_prim_id);
    }
    render() {
        return (
        <label>
            <input type="checkbox" name="is_prim_id" onChange={this.handleCheckPrimId.bind(this)}
            checked={(this.state.is_prim_id == 1) ? true : false}/> &nbsp; Prim ID </label>
        );

    }
}
export default PrimIdFilter;